// Single source of truth for the wizard's steps: id/label for the progress
// UI, `fields` for the trigger()-gated validation useUpsellWizard runs
// before advancing. Mirrors _features/proposals/constants.js's
// PROPOSAL_WIZARD_STEPS shape exactly.
export const UPSELL_WIZARD_STEPS = [
  { id: 1, label: "Customer details", fields: ["title", "company"] },
  { id: 2, label: "Package details", fields: ["subscription", "billingCycle"] },
  { id: 3, label: "Finalize", fields: ["expiryIn", "netTerms"] },
  { id: 4, label: "Review", fields: [] },
];
